export default require("!!./../../webpack/emoji-loader!./../../vendor/emojis/img-apple-64.json");
